(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var objectCreate = Object.create || objectCreatePolyfill
var objectKeys = Object.keys || objectKeysPolyfill
var bind = Function.prototype.bind || functionBindPolyfill

function EventEmitter() {
  if (!this._events || !Object.prototype.hasOwnProperty.call(this, '_events')) {
    this._events = objectCreate(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

var hasDefineProperty;
try {
  var o = {};
  if (Object.defineProperty) Object.defineProperty(o, 'x', { value: 0 });
  hasDefineProperty = o.x === 0;
} catch (err) { hasDefineProperty = false }
if (hasDefineProperty) {
  Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
      return defaultMaxListeners;
    },
    set: function(arg) {
      // check whether the input is a positive number (whose value is zero or
      // greater and not a NaN).
      if (typeof arg !== 'number' || arg < 0 || arg !== arg)
        throw new TypeError('"defaultMaxListeners" must be a positive number');
      defaultMaxListeners = arg;
    }
  });
} else {
  EventEmitter.defaultMaxListeners = defaultMaxListeners;
}

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || isNaN(n))
    throw new TypeError('"n" argument must be a positive number');
  this._maxListeners = n;
  return this;
};

function $getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return $getMaxListeners(this);
};

// These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function emitNone(handler, isFn, self) {
  if (isFn)
    handler.call(self);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self);
  }
}
function emitOne(handler, isFn, self, arg1) {
  if (isFn)
    handler.call(self, arg1);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1);
  }
}
function emitTwo(handler, isFn, self, arg1, arg2) {
  if (isFn)
    handler.call(self, arg1, arg2);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2);
  }
}
function emitThree(handler, isFn, self, arg1, arg2, arg3) {
  if (isFn)
    handler.call(self, arg1, arg2, arg3);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].call(self, arg1, arg2, arg3);
  }
}

function emitMany(handler, isFn, self, args) {
  if (isFn)
    handler.apply(self, args);
  else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      listeners[i].apply(self, args);
  }
}

EventEmitter.prototype.emit = function emit(type) {
  var er, handler, len, args, i, events;
  var doError = (type === 'error');

  events = this._events;
  if (events)
    doError = (doError && events.error == null);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    if (arguments.length > 1)
      er = arguments[1];
    if (er instanceof Error) {
      throw er; // Unhandled 'error' event
    } else {
      // At least give some kind of context to the user
      var err = new Error('Unhandled "error" event. (' + er + ')');
      err.context = er;
      throw err;
    }
    return false;
  }

  handler = events[type];

  if (!handler)
    return false;

  var isFn = typeof handler === 'function';
  len = arguments.length;
  switch (len) {
      // fast cases
    case 1:
      emitNone(handler, isFn, this);
      break;
    case 2:
      emitOne(handler, isFn, this, arguments[1]);
      break;
    case 3:
      emitTwo(handler, isFn, this, arguments[1], arguments[2]);
      break;
    case 4:
      emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
      break;
      // slower
    default:
      args = new Array(len - 1);
      for (i = 1; i < len; i++)
        args[i - 1] = arguments[i];
      emitMany(handler, isFn, this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');

  events = target._events;
  if (!events) {
    events = target._events = objectCreate(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener) {
      target.emit('newListener', type,
          listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (!existing) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
          prepend ? [listener, existing] : [existing, listener];
    } else {
      // If we've already got an array, just append.
      if (prepend) {
        existing.unshift(listener);
      } else {
        existing.push(listener);
      }
    }

    // Check for listener leak
    if (!existing.warned) {
      m = $getMaxListeners(target);
      if (m && m > 0 && existing.length > m) {
        existing.warned = true;
        var w = new Error('Possible EventEmitter memory leak detected. ' +
            existing.length + ' "' + String(type) + '" listeners ' +
            'added. Use emitter.setMaxListeners() to ' +
            'increase limit.');
        w.name = 'MaxListenersExceededWarning';
        w.emitter = target;
        w.type = type;
        w.count = existing.length;
        if (typeof console === 'object' && console.warn) {
          console.warn('%s: %s', w.name, w.message);
        }
      }
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    switch (arguments.length) {
      case 0:
        return this.listener.call(this.target);
      case 1:
        return this.listener.call(this.target, arguments[0]);
      case 2:
        return this.listener.call(this.target, arguments[0], arguments[1]);
      case 3:
        return this.listener.call(this.target, arguments[0], arguments[1],
            arguments[2]);
      default:
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; ++i)
          args[i] = arguments[i];
        this.listener.apply(this.target, args);
    }
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = bind.call(onceWrapper, state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  if (typeof listener !== 'function')
    throw new TypeError('"listener" argument must be a function');
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      if (typeof listener !== 'function')
        throw new TypeError('"listener" argument must be a function');

      events = this._events;
      if (!events)
        return this;

      list = events[type];
      if (!list)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = objectCreate(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else
          spliceOne(list, position);

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (!events)
        return this;

      // not listening for removeListener, no need to emit
      if (!events.removeListener) {
        if (arguments.length === 0) {
          this._events = objectCreate(null);
          this._eventsCount = 0;
        } else if (events[type]) {
          if (--this._eventsCount === 0)
            this._events = objectCreate(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = objectKeys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = objectCreate(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (!events)
    return [];

  var evlistener = events[type];
  if (!evlistener)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ? unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
};

// About 1.5x faster than the two-arg version of Array#splice().
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)
    list[i] = list[k];
  list.pop();
}

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function objectCreatePolyfill(proto) {
  var F = function() {};
  F.prototype = proto;
  return new F;
}
function objectKeysPolyfill(obj) {
  var keys = [];
  for (var k in obj) if (Object.prototype.hasOwnProperty.call(obj, k)) {
    keys.push(k);
  }
  return k;
}
function functionBindPolyfill(context) {
  var fn = this;
  return function () {
    return fn.apply(context, arguments);
  };
}

},{}],2:[function(require,module,exports){
'use strict'
/*eslint-env browser */

module.exports = {
  /**
   * Create a <style>...</style> tag and add it to the document head
   * @param {string} cssText
   * @param {object?} options
   * @return {Element}
   */
  createStyle: function (cssText, options) {
    var container = document.head || document.getElementsByTagName('head')[0]
    var style = document.createElement('style')
    options = options || {}
    style.type = 'text/css'
    if (options.href) {
      style.setAttribute('data-href', options.href)
    }
    if (style.sheet) { // for jsdom and IE9+
      style.innerHTML = cssText
      style.sheet.cssText = cssText
    }
    else if (style.styleSheet) { // for IE8 and below
      style.styleSheet.cssText = cssText
    }
    else { // for Chrome, Firefox, and Safari
      style.appendChild(document.createTextNode(cssText))
    }
    if (options.prepend) {
      container.insertBefore(style, container.childNodes[0]);
    } else {
      container.appendChild(style);
    }
    return style
  }
}

},{}],3:[function(require,module,exports){
!function(t,e){"object"==typeof exports&&"undefined"!=typeof module?e(exports):"function"==typeof define&&define.amd?define(["exports"],e):e((t=t||self).webVitals={})}(this,(function(t){"use strict";var e,n,i=function(){return"".concat(Date.now(),"-").concat(Math.floor(8999999999999*Math.random())+1e12)},a=function(t){var e=arguments.length>1&&void 0!==arguments[1]?arguments[1]:-1;return{name:t,value:e,delta:0,entries:[],id:i(),isFinal:!1}},r=function(t,e){try{if(PerformanceObserver.supportedEntryTypes.includes(t)){var n=new PerformanceObserver((function(t){return t.getEntries().map(e)}));return n.observe({type:t,buffered:!0}),n}}catch(t){}},o=!1,s=!1,u=function(t){o=!t.persisted},c=function(){addEventListener("pagehide",u),addEventListener("unload",(function(){}))},d=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1];s||(c(),s=!0),addEventListener("visibilitychange",(function(e){var n=e.timeStamp;"hidden"===document.visibilityState&&t({timeStamp:n,isUnloading:o})}),{capture:!0,once:e})},f=function(t,e,n,i){var a;return function(){n&&e.isFinal&&n.disconnect(),e.value>=0&&(i||e.isFinal||"hidden"===document.visibilityState)&&(e.delta=e.value-(a||0),(e.delta||e.isFinal||void 0===a)&&(t(e),a=e.value))}},p=function(){return void 0===e&&(e="hidden"===document.visibilityState?0:1/0,d((function(t){var n=t.timeStamp;return e=n}),!0)),{get timeStamp(){return e}}},l=function(){return n||(n=new Promise((function(t){return["scroll","keydown","pointerdown"].map((function(e){addEventListener(e,t,{once:!0,passive:!0,capture:!0})}))}))),n};t.getCLS=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=a("CLS",0),i=function(t){t.hadRecentInput||(n.value+=t.value,n.entries.push(t),s())},o=r("layout-shift",i),s=f(t,n,o,e);d((function(t){var e=t.isUnloading;o&&o.takeRecords().map(i),e&&(n.isFinal=!0),s()}))},t.getFCP=function(t){var e=a("FCP"),n=p(),i=r("paint",(function(t){"first-contentful-paint"===t.name&&t.startTime<n.timeStamp&&(e.value=t.startTime,e.isFinal=!0,e.entries.push(t),o())})),o=f(t,e,i)},t.getFID=function(t){var e=a("FID"),n=p(),i=function(t){t.startTime<n.timeStamp&&(e.value=t.processingStart-t.startTime,e.entries.push(t),e.isFinal=!0,s())},o=r("first-input",i),s=f(t,e,o);d((function(){o&&(o.takeRecords().map(i),o.disconnect())}),!0),o||window.perfMetrics&&window.perfMetrics.onFirstInputDelay&&window.perfMetrics.onFirstInputDelay((function(t,i){i.timeStamp<n.timeStamp&&(e.value=t,e.isFinal=!0,e.entries=[{entryType:"first-input",name:i.type,target:i.target,cancelable:i.cancelable,startTime:i.timeStamp,processingStart:i.timeStamp+t}],s())}))},t.getLCP=function(t){var e=arguments.length>1&&void 0!==arguments[1]&&arguments[1],n=a("LCP"),i=p(),o=function(t){var e=t.startTime;e<i.timeStamp?(n.value=e,n.entries.push(t)):n.isFinal=!0,u()},s=r("largest-contentful-paint",o),u=f(t,n,s,e),c=function(){n.isFinal||(s&&s.takeRecords().map(o),n.isFinal=!0,u())};l().then(c),d(c,!0)},t.getTTFB=function(t){var e,n=a("TTFB");e=function(){try{var e=performance.getEntriesByType("navigation")[0]||function(){var t=performance.timing,e={entryType:"navigation",startTime:0};for(var n in t)"navigationStart"!==n&&"toJSON"!==n&&(e[n]=Math.max(t[n]-t.navigationStart,0));return e}();n.value=n.delta=e.responseStart,n.entries=[e],n.isFinal=!0,t(n)}catch(t){}},"complete"===document.readyState?setTimeout(e,0):addEventListener("pageshow",e)},Object.defineProperty(t,"__esModule",{value:!0})}));

},{}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cookieManager = _interopRequireDefault(require("./cookie-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var addVisitedCookie = function addVisitedCookie() {
  var cookieManager = new _cookieManager["default"]();
  var cookieName = 'isReturningUser';
  var userVisitedSite = cookieManager.getCookieValue(cookieName);

  var createVisitedStateCookie = function createVisitedStateCookie() {
    var nextYear = new Date().setFullYear(new Date().getFullYear() + 1);
    cookieManager.createCookie(cookieName, 'true', nextYear);
  };

  if (!userVisitedSite) {
    createVisitedStateCookie();
  }
};

var _default = addVisitedCookie;
exports["default"] = _default;

},{"./cookie-manager":9}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BannerGeo =
/*#__PURE__*/
function () {
  function BannerGeo(opts) {
    var _this = this;

    _classCallCheck(this, BannerGeo);

    _defineProperty(this, "modalHandler", function (modal) {
      var _modal$dataset = modal.dataset,
          modalAttr = _modal$dataset.modalAttr,
          geo = _modal$dataset.geo;

      if (modalAttr) {
        var modalInfo = _this.convertToObject(modalAttr);

        if (modalInfo) {
          var countries = _this.convertToObject(geo || '[]');

          var locationData = _this.convertToObject(sessionStorage.getItem('GEO_LOCATION_DATA') || '{}');

          var clientCountryCode = locationData.countryCode;

          if (countries.length) {
            // add banner management attribs to modal if client country is allowed
            if (countries.indexOf(clientCountryCode) > -1) {
              _this.setAttributes(modal, modalInfo);
            }
          } else {
            // add banner management attribs to modal for all countries by default
            _this.setAttributes(modal, modalInfo);
          }
        }
      }
    });

    this.opts = Object.assign({
      modals: '.modal[data-modal-attr]'
    }, opts);
    this.init();
  }

  _createClass(BannerGeo, [{
    key: "init",
    value: function init() {
      this.modals = document.querySelectorAll(this.opts.modals);

      _toConsumableArray(this.modals).forEach(this.modalHandler);
    }
  }, {
    key: "setAttributes",
    value: function setAttributes(modal, attrs) {
      if (modal) {
        Object.keys(attrs).forEach(function (prop) {
          modal.setAttribute(prop, attrs[prop]);
        });
      }
    }
  }, {
    key: "convertToObject",
    value: function convertToObject(str) {
      var result = null;

      try {
        result = JSON.parse(str);
      } catch (err) {
        result = null;
      }

      return result;
    }
  }]);

  return BannerGeo;
}();

var _default = BannerGeo;
exports["default"] = _default;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _storageHelper = _interopRequireDefault(require("./storage-helper"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// 1) data-banner-type="exit-intent" data-exit-intent-offset="30" data-banner-lifetime="24"
// 2) data-banner-type="page-load" data-banner-lifetime="24"
// 3) data-banner-type="scroll" data-scroll-distance="400" data-banner-lifetime="24"
var BannerManagement =
/*#__PURE__*/
function () {
  function BannerManagement(opts) {
    var _this = this;

    _classCallCheck(this, BannerManagement);

    _defineProperty(this, "scrollElement", document.scrollingElement || document.documentElement);

    _defineProperty(this, "queue", []);

    _defineProperty(this, "storageName", 'bannersQueue');

    _defineProperty(this, "bannerTypesInfo", {
      'exit-intent': 'attachExitIntent',
      'page-load': 'attachOnPageLoad',
      scroll: 'attachOnScroll'
    });

    _defineProperty(this, "onMouseMove", function (e) {
      var clientY = e.clientY;

      if (clientY <= _this.exitOffset) {
        _this.addModalToStorage();

        document.removeEventListener('mousemove', _this.onMouseMove);
      }
    });

    _defineProperty(this, "onScroll", function () {
      if (_this.scrollElement.scrollTop >= _this.scrollDistance) {
        _this.addModalToStorage();

        window.removeEventListener('scroll', _this.onScroll);
      }
    });

    this.opts = Object.assign({
      modals: '[data-banner-type]'
    }, opts);
    this.init();
  }

  _createClass(BannerManagement, [{
    key: "init",
    value: function init() {
      this.sessionStorageHelper = null;
      this.localStorageHelper = null;
      this.modalToShow = null;
      this.setStartState();
    }
  }, {
    key: "setStartState",
    value: function setStartState() {
      this.modals = document.querySelectorAll(this.opts.modals);
      this.makeQueue();

      if (this.queue.length) {
        this.modalToShow = this.queue[0];
        this.attachEvents();
      }
    }
  }, {
    key: "makeLocalStorage",
    value: function makeLocalStorage() {
      this.localStorageHelper = new _storageHelper["default"](this.storageName, {
        storageAPI: 'localStorage',
        onAddProp: function onAddProp() {},
        onDeleteProp: function onDeleteProp() {}
      });
    }
  }, {
    key: "makeSessionStorage",
    value: function makeSessionStorage() {
      this.sessionStorageHelper = new _storageHelper["default"](this.storageName, {
        storageAPI: 'sessionStorage',
        onAddProp: function onAddProp() {},
        onDeleteProp: function onDeleteProp() {}
      });
    }
  }, {
    key: "getStoragesWithItem",
    value: function getStoragesWithItem(id) {
      var sessionStorage = this.sessionStorageHelper || new _storageHelper["default"](this.storageName, {
        storageAPI: 'sessionStorage'
      });
      var localStorage = this.localStorageHelper || new _storageHelper["default"](this.storageName, {
        storageAPI: 'localStorage'
      });
      var storagesList = [sessionStorage, localStorage].reduce(function (storages, currentStorage) {
        if (currentStorage.hasItem(id)) {
          storages.push(currentStorage);
        }

        return storages;
      }, []);
      return storagesList;
    }
  }, {
    key: "checkBannerSettings",
    value: function checkBannerSettings(modal) {
      if (!modal) return;
      var currentSettings = modal.dataset.modalAttr;
      var id = modal.id;

      if (id) {
        var storagesWithModal = this.getStoragesWithItem(id);
        storagesWithModal.forEach(function (storageAPI) {
          var itemInStorage = storageAPI.getProp(id);

          if (itemInStorage) {
            var settingsFromStorage = itemInStorage.data.bannerSettings;

            if (JSON.stringify(currentSettings) !== settingsFromStorage) {
              storageAPI.removeProp(id);
            }
          }
        });
      }
    }
  }, {
    key: "makeQueue",
    value: function makeQueue() {
      var _this2 = this;

      // make queue from modals that haven't been shown
      this.queue = [];

      _toConsumableArray(this.modals).forEach(function (modal) {
        var _modal$dataset = modal.dataset,
            bannerType = _modal$dataset.bannerType,
            bannerLifetime = _modal$dataset.bannerLifetime,
            modalAttr = _modal$dataset.modalAttr;

        if (bannerType) {
          var id = modal.id;
          var readyToShow = true; // make inst with sessionStorage api when banner doesn't have lifetime attrib

          if (!_this2.sessionStorageHelper && !bannerLifetime) {
            _this2.makeSessionStorage();
          } // make inst with localStorage api when banner have lifetime attrib


          if (!_this2.localStorageHelper && bannerLifetime) {
            _this2.makeLocalStorage();
          }

          var storageAPI = bannerLifetime ? _this2.localStorageHelper : _this2.sessionStorageHelper; // remove banner from web storage if it has new settings

          _this2.checkBannerSettings(modal); // add banner to queue when it isn't added to web storage


          readyToShow = !storageAPI.hasItem(id);

          if (readyToShow) {
            _this2.queue.push({
              id: id,
              bannerType: bannerType,
              bannerLifetime: _this2.hoursToMs(bannerLifetime),
              storageAPI: storageAPI,
              bannerSettings: JSON.stringify(modalAttr)
            });
          }
        }
      });
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      if (this.modalToShow) {
        var bannerType = this.modalToShow.bannerType;
        var bannerFnName = this.bannerTypesInfo[bannerType];
        var fn = this[bannerFnName];

        if (typeof fn === 'function') {
          fn.call(this);
        }
      }
    }
  }, {
    key: "attachExitIntent",
    value: function attachExitIntent() {
      var _this3 = this;

      if (this.modalToShow) {
        var modal = this.getModalDomEl();

        if (modal) {
          this.exitOffset = +modal.dataset.exitIntentOffset || 10;
          clearTimeout(this.exitIntentTimer);
          this.exitIntentTimer = setTimeout(function () {
            document.addEventListener('mousemove', _this3.onMouseMove);
          }, 1000);
        }
      }
    }
  }, {
    key: "attachOnPageLoad",
    value: function attachOnPageLoad() {
      if (this.modalToShow) {
        this.addModalToStorage();
      }
    }
  }, {
    key: "attachOnScroll",
    value: function attachOnScroll() {
      if (this.modalToShow) {
        var modal = this.getModalDomEl();

        if (modal) {
          this.scrollDistance = modal.dataset.scrollDistance;
          window.addEventListener('scroll', this.onScroll);
        }
      }
    }
  }, {
    key: "addModalToStorage",
    value: function addModalToStorage() {
      if (this.modalToShow) {
        var _this$modalToShow = this.modalToShow,
            id = _this$modalToShow.id,
            bannerLifetime = _this$modalToShow.bannerLifetime,
            storageAPI = _this$modalToShow.storageAPI,
            bannerSettings = _this$modalToShow.bannerSettings;
        var modal = document.getElementById(id);

        if (modal) {
          this.showModal(modal);
          storageAPI.addProp(id, bannerLifetime, {
            bannerSettings: bannerSettings
          });
        }
      }
    }
  }, {
    key: "showModal",
    value: function showModal(modal) {
      var $m = jQuery(modal);

      if ($m.length) {
        $m.modal('show');
      }
    }
  }, {
    key: "getModalDomEl",
    value: function getModalDomEl() {
      var el = null;

      if (this.modalToShow) {
        var id = this.modalToShow.id;
        el = document.getElementById(id);
      }

      return el;
    }
  }, {
    key: "hoursToMs",
    value: function hoursToMs(h) {
      return +h * 60 * 60 * 1000;
    }
  }]);

  return BannerManagement;
}();

var _default = BannerManagement;
exports["default"] = _default;

},{"./storage-helper":14}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Carousel =
/*#__PURE__*/
function () {
  function Carousel(element) {
    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Carousel);

    if (element) {
      this.element = $(element);
      this.previewMode = this.element.is('.preview-mode');
      this.currentIndex = 0;
      this.init();
    } else {
      console.error('Typewriter::constructor', 'element not found');
    }
  }

  _createClass(Carousel, [{
    key: "init",
    value: function init() {
      this.registerEvents();

      if (this.previewMode) {
        this.setPreviewClass();
      }
    }
  }, {
    key: "fireGtmEvent",
    value: function fireGtmEvent() {
      var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      try {
        // check for dataLayer (gtm events) support
        if ('dataLayer' in window && typeof window.dataLayer.push == 'function') {
          if (event) {
            // set default
            event.event = event.event || 'GAevent';
            event.eventCategory = event.eventCategory || '';
            event.eventAction = event.eventAction || 'Slider';
            event.eventLabel = event.eventLabel || '';
            event.eventLabel = event.eventLabel.trim();
            window.dataLayer.push(event);
          }
        }
      } catch (error) {
        console.error('Faild to write Slider GTM Event');
      }
    }
  }, {
    key: "registerEvents",
    value: function registerEvents() {
      var _this = this;

      // if click on right_teaser
      if (this.previewMode) {
        $(this.element).on('click', '.carousel-item', function (e) {
          var el = $(e.currentTarget);
          _this.currentIndex = el.data('index');

          if (_this.previewMode) {// this.removePreviewClasses();
          }

          if (el.is(':not(.active)')) {
            var previewTitle = $('.preview-title', el).text();

            if (el.is('.preview-left')) {
              $(_this.element).carousel('prev');

              _this.fireGtmEvent({
                eventCategory: 'homepage slider previous',
                eventLabel: previewTitle
              });
            } else if (el.is('.preview-right')) {
              $(_this.element).carousel('next');

              _this.fireGtmEvent({
                eventCategory: 'homepage slider next',
                eventLabel: previewTitle
              });
            } else {
              if (_this.currentIndex >= 0) {
                $(_this.element).carousel(_this.currentIndex);

                _this.fireGtmEvent({
                  eventCategory: 'homepage slider',
                  eventLabel: _this.currentIndex
                });
              }
            }
          }
        });
      }

      if (this.previewMode) {
        // this.element.on('slide.bs.carousel', (e) => this.onSlideStart(e));
        this.element.on('slide.bs.carousel', function (e) {
          return _this.onSlideComplete(e);
        });
      }

      this.element.on('swipeleft', function (e) {
        $(_this.element).carousel('next');
      });
      this.element.on('swiperight', function (e) {
        $(_this.element).carousel('prev');
      }); // gtm

      this.element.on('click', '.btn,.btn-impv', function (e) {
        var label = $(e.currentTarget).text();

        _this.fireGtmEvent({
          eventCategory: 'homepage slider CTA',
          eventLabel: label,
          eventAction: 'Click'
        });
      });
    }
  }, {
    key: "onSlideStart",
    value: function onSlideStart(e) {
      var to = e.to;
      this.currentIndex = to;
      this.removePreviewClasses();
      this.setPreviewClass();
    }
  }, {
    key: "onSlideComplete",
    value: function onSlideComplete(e) {
      var to = e.to;
      this.currentIndex = to;
      this.removePreviewClasses();
      this.setPreviewClass();
    }
  }, {
    key: "removePreviewClasses",
    value: function removePreviewClasses() {
      var index = this.currentIndex || 0;
      var slides = $('.carousel-item', this.element);
      slides.each(function (_, element) {
        var left = index == 0 ? slides.length - 1 : index - 1;
        var right = index == slides.length - 1 ? 0 : index + 1;
        var elementIndex = $(element).data('index');

        if (elementIndex !== left) {
          $(element).removeClass(['preview', 'preview-left']);
        }

        if (elementIndex !== right) {
          $(element).removeClass(['preview', 'preview-right']);
        }
      });
    }
  }, {
    key: "setPreviewClass",
    value: function setPreviewClass() {
      var index = this.currentIndex || 0;
      var slides = $('.carousel-item', this.element);
      var left = index == 0 ? slides.length - 1 : index - 1;
      var right = index == slides.length - 1 ? 0 : index + 1;
      slides.each(function (_, element) {
        var elementIndex = $(element).data('index');

        if (elementIndex == left) {
          $(element).addClass(['preview', 'preview-left']);
        }

        if (elementIndex == right) {
          $(element).addClass(['preview', 'preview-right']);
        }
      });
    }
  }]);

  return Carousel;
}();

exports["default"] = Carousel;

_defineProperty(Carousel, "register", function () {
  $('.carousel', document).each(function (_, element) {
    var args = {};
    new Carousel(element, args);
  });
});

},{}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.registerCookieConsent = void 0;

var _userInfo = _interopRequireDefault(require("./user-info"));

var _cookieManager = _interopRequireDefault(require("./cookie-manager"));

var _translateService = require("impv/src/js/services/translate-service");

require("impv/src/scss/components/cookie-consent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var registerCookieConsent = function registerCookieConsent() {
  // Listen for the event.
  document.addEventListener('EuropeIdentifyEvent', function (e) {
    // cookie consent is relevant for europe users only
    var isEuropeUser = new _userInfo["default"]().isEuropeUser();
    if (!isEuropeUser || isEuropeUser == 'false') return; //new CookieConsent().init();
  }, false);
};

exports.registerCookieConsent = registerCookieConsent;

var CookieConsent =
/*#__PURE__*/
function () {
  function CookieConsent() {
    _classCallCheck(this, CookieConsent);

    this.cookieConsentName = 'cookieconsent_status';
    this.cookieConsentClosed = 'cookieconsent_was_closed';
    this.cookieManager = new _cookieManager["default"]();
  } // init coockie consent: in case cookie "cookieconsent_status" not exist - create it for the first time with europe-user value


  _createClass(CookieConsent, [{
    key: "init",
    value: function init() {
      var _this = this;

      var cookieConsentBarWasClosed = this.cookieManager.getCookieValue(this.cookieConsentClosed); // if cookie consent not exist or status is "europe-user"- create one and show banner

      if (!cookieConsentBarWasClosed) {
        this.createCookieConsentStatus('europe-user');
        $(function (_) {
          _this.showCookieConsentBanner();
        });
      }
    } // add cookie consent html element to body, add close banner event handler

  }, {
    key: "showCookieConsentBanner",
    value: function showCookieConsentBanner() {
      var _this2 = this;

      $('body').addClass('show-cookie-consent-banner');
      $('body').prepend(this.getConsentBannerHTMLElement());
      var event = new Event('cookieconsentbannerinserted');
      document.dispatchEvent(event); // $('body').prepend(this.getConsentBannerStyle());
      // add click event handler for close button (remove banner, set cookie to "dismiss")

      $('.close-btn-consent').on('click', function () {
        $('.cookie-consent-banner').remove();
        $('#cookie-consent-styling').remove();

        _this2.createCookieConsentStatus('dismiss');

        _this2.setCookieClosedVal();
      });
    } // create cookie consent with expiration of 1 year

  }, {
    key: "createCookieConsentStatus",
    value: function createCookieConsentStatus(cookieConsentStatusValue) {
      // create cookie
      var nextYear = new Date().setFullYear(new Date().getFullYear() + 1);
      this.cookieManager.createCookie(this.cookieConsentName, cookieConsentStatusValue, nextYear);
    }
  }, {
    key: "setCookieClosedVal",
    value: function setCookieClosedVal() {
      var nextYear = new Date().setFullYear(new Date().getFullYear() + 1);
      this.cookieManager.createCookie(this.cookieConsentClosed, 'closed', nextYear);
    } // get banner html element

  }, {
    key: "getConsentBannerHTMLElement",
    value: function getConsentBannerHTMLElement() {
      var bannerTexts = this.initBannerTexts();
      var bannerStyles = this.initBannerStyles();
      var closeBannerElement = "<a href='javascript:;' class='close-btn-consent' " + bannerStyles.closeBanner + '>&times;</a>';
      var learnMoreElement = '<a href=' + bannerTexts.cookiePolicyURL + bannerStyles.learnMore + '>' + bannerTexts.learnMore + '</a>';
      var cookiePolicyElement = '<a href=' + bannerTexts.cookiePolicyURL + bannerStyles.cookiePolicy + '>' + bannerTexts.cookiePolicy + '</a>.&nbsp;';
      var cookieBannerContainer = "<div class='container responsive-container'> <div class='row'>" + "<p class='content-text col-12'>" + bannerTexts.cookieBannerParagraph + '&nbsp;' + closeBannerElement + '</p>' + '</div>' + '</div>';
      return "<div class='cookie-consent-banner' " + bannerStyles.cookieBanner + '>' + cookieBannerContainer + '</div>';
    }
  }, {
    key: "initBannerTexts",
    value: function initBannerTexts() {
      return {
        cookieBannerParagraph: (0, _translateService.translate)('cookie_consent.cookie_banner_paragraph', 'By using this site you agree to the use of cookies for analytics, personalized content, ads, and as described in our &nbsp;<a href="https://www.imperva.com/Other/Privacy/Cookies" style=" color: white; text-decoration: underline;" target="_blank">Cookie Policy</a>.&nbsp;<a href="https://www.imperva.com/Other/Privacy/Cookies" style=" color: white; text-decoration: underline;" target="_blank">Learn More</a>')
      };
    } // init styles for banner html elements

  }, {
    key: "initBannerStyles",
    value: function initBannerStyles() {
      return {
        learnMore: " target='_blank'",
        cookiePolicy: " target='_blank'",
        cookieBanner: ' ',
        closeBanner: ' '
      };
    } // init 'content-text', 'responsive-container' classes
    // getConsentBannerStyle() {
    //   return (
    //     '<style id="cookie-consent-styling">' +
    //     '@media (min-width: 1024px){' +
    //     'div#livechat-compact-container{' +
    //     'bottom: 50px !important;' +
    //     '}}' +
    //     '@media (min-width: 768px) and (max-width: 1023px) {' +
    //     'div#livechat-compact-container{' +
    //     'bottom: 66px !important;}}' +
    //     '.content-text{' +
    //     'color: white !important;' +
    //     'font-size: 14px !important;' +
    //     'line-height: 40px !important;' +
    //     'margin-bottom: 0px !important;' +
    //     '}' +
    //     '.responsive-container{' +
    //     'margin-right: auto;' +
    //     'margin-left: auto;' +
    //     'padding: 0 15px;' +
    //     '}' +
    //     '@media(max-width: 992px){' +
    //     '.content-text{' +
    //     'line-height: 28px !important;' +
    //     '.responsive-container{' +
    //     'padding: 10px 15px !important;' +
    //     '}' +
    //     '}' +
    //     '.responsive-container{' +
    //     'width:100%;' +
    //     '}}' +
    //     '@media (min-width:1420px){' +
    //     '.responsive-container{' +
    //     'width:1390px !important;' +
    //     '}' +
    //     '}' +
    //     '@media (max-width:1420px){' +
    //     '.responsive-container{' +
    //     'max-width: calc(100% - 57px)!important;' +
    //     'padding:0px !important' +
    //     '}' +
    //     '}' +
    //     '@media (min-width: 1200px) {' +
    //     '.close-btn-consent{' +
    //     'float: left;' +
    //     'line-height: 34px;' +
    //     'margin-right: 10px;' +
    //     '}' +
    //     '.content-text{line-height: 40px;}' +
    //     '}' +
    //     '@media (min-width: 768px) and (max-width: 1199px) {' +
    //     '.cookie-consent-banner{' +
    //     'padding-top: 5px;' +
    //     'padding-bottom: 5px;' +
    //     '}' +
    //     '.close-btn-consent{' +
    //     'position: absolute;' +
    //     'top: -5px;' +
    //     'left: 10px;' +
    //     'margin-right: 10px;' +
    //     '}' +
    //     '.content-text{' +
    //     'padding-left: 30px;' +
    //     ' line-height: 22px;}' +
    //     '}' +
    //     '@media (max-width: 767px){' +
    //     '.close-btn-consent{' +
    //     'position: absolute;' +
    //     'top: 0px;' +
    //     'right:10px;' +
    //     '}' +
    //     '.cookie-consent-banner{position: relative !important;}' +
    //     '.content-text{padding-right: 30px; line-height: 22px;}' +
    //     '}' +
    //     '</style>'
    //   );
    // }

  }]);

  return CookieConsent;
}();

exports["default"] = CookieConsent;

},{"./cookie-manager":9,"./user-info":15,"impv/src/js/services/translate-service":18,"impv/src/scss/components/cookie-consent.scss":20}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var CookieManager =
/*#__PURE__*/
function () {
  function CookieManager() {
    _classCallCheck(this, CookieManager);
  }

  _createClass(CookieManager, [{
    key: "getCookieValue",
    // get cookie value per name
    value: function getCookieValue(cookieName) {
      // Get all the cookies pairs in an array
      var cookieArray = document.cookie.split(';');
      var cookiesObj = {}; // convert cookie array to [key:value] object

      cookieArray.forEach(function (cookieItem) {
        var _cookieItem$split = cookieItem.split('='),
            _cookieItem$split2 = _slicedToArray(_cookieItem$split, 2),
            name = _cookieItem$split2[0],
            value = _cookieItem$split2[1];

        cookiesObj[name.trim()] = value;
      });
      return cookiesObj[cookieName];
    } // Check if cookie exist

  }, {
    key: "isCookieExist",
    value: function isCookieExist(cookieName) {
      return this.getCookieValue(cookieName) != undefined;
    } // Create new cookie

  }, {
    key: "createCookie",
    value: function createCookie(cookieName, cookieValue, expirationDate) {
      if (!expirationDate) {
        expirationDate = new Date(Date.now() + 60000
        /** 1 min */
        );
      }

      var newCookie = cookieName + '=' + cookieValue + '; expires=' + new Date(expirationDate).toUTCString() + '; path=/';
      document.cookie = newCookie;
    }
  }]);

  return CookieManager;
}();

exports["default"] = CookieManager;

},{}],10:[function(require,module,exports){
"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* 
    Optimizely Successful Experiment: Shift Chat Up
*/
(function (window, document, undefined) {
  var observer = new MutationObserver(function (mutations, obs) {
    // Optimizely Library
    var optimizelyLibrary = window.optimizely;

    if (optimizelyLibrary) {
      var utils = window.optimizely.get('utils');
      var error = utils.error; // Document Cookie

      var docCookie = document.cookie;

      if (docCookie) {
        var alertBoxClosed = document.cookie.indexOf('OptanonAlertBoxClosed') > 1;

        if (!alertBoxClosed) {
          utils.waitForElement('#drift-frame-controller').then(function (chatBox) {
            chatBox.classList.add('moved-up'); // in addition: move chat window up

            document.querySelector('#drift-frame-chat').classList.add('moved-up');
            return Promise.all([chatBox, utils.waitForElement('#onetrust-banner-sdk[style*="display: none;"]')]);
          }).then(function (_ref) {
            var _ref2 = _slicedToArray(_ref, 2),
                chatBox = _ref2[0],
                otBanner = _ref2[1];

            chatBox.classList.remove('moved-up');
            document.querySelector('#drift-frame-chat').classList.remove('moved-up');
          })["catch"](error);
        }

        obs.disconnect();
        return;
      }
    }
  });
  observer.observe(document, {
    childList: true,
    subtree: true
  });
})(window, document);

},{}],11:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _events = require("events");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

// auto focus on key press
var runOnce = 'impv_dropdown_auto_focus';

if (!(runOnce in window)) {
  $(function (_) {
    window[runOnce] = true;

    jQuery.expr[':'].startwith = function (a, i, m) {
      return jQuery(a).text().toUpperCase().indexOf(m[3].toUpperCase()) == 0;
    };

    var timeout = null;
    var selectText = '';

    function clearSelect() {
      selectText = '';
    }

    $(document).on('keydown', '.impv-dropdown', function (event) {
      clearTimeout(timeout);
      /** clear the selected text after 1 sec */

      timeout = setTimeout(clearSelect, 1000);
      var container = $(event.currentTarget);

      var _char = String.fromCharCode(event.keyCode);

      selectText += _char;
      var selector = ".dropdown-item:visible:startwith('".concat(selectText, "')");
      $(selector, container).first().focus();
    });
  });
}

var DropDownSelect =
/*#__PURE__*/
function (_EventEmitter) {
  _inherits(DropDownSelect, _EventEmitter);

  _createClass(DropDownSelect, null, [{
    key: "register",
    value: function register(selector) {
      // register once
      if (global.DROP_DOWN_SLECT_GUARD_RUN_ONCE) {
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }

      selector = selector || '.dropdown.dropdown-select';

      if ($(selector).length > 0) {
        global.DROP_DOWN_SLECT_GUARD_RUN_ONCE = new DropDownSelect();
        return global.DROP_DOWN_SLECT_GUARD_RUN_ONCE;
      }
    }
  }]);

  function DropDownSelect() {
    var _this;

    _classCallCheck(this, DropDownSelect);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DropDownSelect).call(this));

    _this.init();

    return _this;
  }

  _createClass(DropDownSelect, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      $('.impv-dropdown .dropdown-select-btn').on('click', function (e) {
        if ($(e.currentTarget).hasClass('no-options')) {
          e.preventDefault();
        } else {
          var currentBtn$ = $(e.currentTarget);
          var menuId = currentBtn$.attr('id');
          var value = currentBtn$.attr('data-value');

          if ($(document).width() <= 767) {
            setTimeout(function () {
              e.currentTarget.scrollIntoView({
                block: 'start',
                behavior: 'smooth'
              });
            }, 10);
          }

          _this2.hideSelectedItem(menuId, value);
        }
      });
      $('.impv-dropdown .dropdown-item:not(.prev-def)').on('click', function (e) {
        e.preventDefault();
        var item$ = $(e.currentTarget);
        var parent$ = item$.parents('.dropdown-select');
        parent$.find('.dropdown-select-btn').attr('data-value', item$.attr('data-value')).attr('data-source', item$.attr('data-source')).find('.name').text(item$.text());
        parent$.trigger('select_changed', {
          parent$: parent$,
          item$: item$
        });

        _this2.emit('select_changed', parent$, item$);
      });
    }
  }, {
    key: "hideSelectedItem",
    value: function hideSelectedItem(menuId, value) {
      $(".impv-dropdown .dropdown-menu[aria-labelledby=\"".concat(menuId, "\"] .dropdown-item")).each(function (_, e) {
        e = $(e);

        if (e.attr('data-value') == value || e.hasClass('filtered')) {
          e.hide();
        } else {
          e.show();
        }
      });
    }
  }, {
    key: "chooseItem",
    value: function chooseItem(parentElem, dataSource) {
      $('.' + parentElem + ' .dropdown-item[data-source="' + dataSource + '"]').click();
    }
  }]);

  return DropDownSelect;
}(_events.EventEmitter);

exports["default"] = DropDownSelect;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"events":1}],12:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initGTMScript = void 0;

var initGTMScript = function initGTMScript() {
  /** ----------GTM DataLayer sending START---------- **/
  jQuery(document).on('click', '[gtm-track]', function (e) {
    var clickedCTA = jQuery(e.currentTarget);
    var eventCategory = clickedCTA.attr('event-category');
    var eventAction = clickedCTA.attr('event-action');
    var eventLabel = clickedCTA.attr('event-label');
    var dataLayerToSend = {
      event: 'GAevent',
      eventCategory: eventCategory,
      eventAction: eventAction,
      eventLabel: eventLabel
    };

    if (!global.dataLayer) {
      global.dataLayer = [];
    }

    global.dataLayer.push(dataLayerToSend);
  });
};

exports.initGTMScript = initGTMScript;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],13:[function(require,module,exports){
'use strict';

document.addEventListener('DOMContentLoaded', function () {
  oneTrust();
}, false);

function oneTrust() {
  var buttons = document.querySelector('#onetrust-button-group');
  var holder = document.querySelector('#onetrust-banner-sdk');

  if (buttons !== null) {
    if (buttons.querySelectorAll('button').length === 2) {
      buttons.querySelector('#onetrust-pc-btn-handler').classList.add('cookie-setting-link-btn');
    } else if (buttons.querySelectorAll('button').length === 3) {
      if (window.getComputedStyle(holder, null).getPropertyValue('background-color') === 'rgb(0, 0, 0)') {
        buttons.querySelectorAll('button')[1].classList.add('btn-white');
      }
    } // Custom drift widget placement based on oneTrust


    var acceptBtn = document.querySelector('#onetrust-accept-btn-handler');
    var closeBtn = document.querySelector('.onetrust-close-btn-handler');
    if (closeBtn) closeBtn.addEventListener('click', moveDriftDown);
    if (acceptBtn) acceptBtn.addEventListener('click', moveDriftDown);
  } else {
    setTimeout(oneTrust, 15);
  }
}

function moveDriftDown() {
  var driftChat = document.getElementById('driftStyles'); // jQuery works here

  if (driftChat) $(driftChat).html('#drift-frame-controller{z-index:950 !important} #drift-frame-chat{bottom:89px !important} #drift-frame-controller{bottom:24px !important}');
}

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

// [add, remove, remove after time] properties in objects that is stored in localStorage or sessionStorage
var StorageHelper =
/*#__PURE__*/
function () {
  function StorageHelper(fieldName, opts) {
    _classCallCheck(this, StorageHelper);

    var id = function id() {};

    this.fieldName = fieldName;
    this.opts = Object.assign({
      storageAPI: 'localStorage',
      onAddProp: id,
      onDeleteProp: id
    }, opts);
    this.storage = window[this.opts.storageAPI];
    this.init();
  }

  _createClass(StorageHelper, [{
    key: "init",
    value: function init() {
      if (this.opts.storageAPI === 'localStorage') {
        this.checkProps();
      }
    }
  }, {
    key: "checkProps",
    value: function checkProps() {
      var _this = this;

      var items = this.getItem(this.fieldName);

      if (items) {
        // remove item's property if lifetime expired
        Object.keys(items).forEach(function (propName) {
          var prop = items[propName];
          var lifetime = prop.lifetime,
              created = prop.created,
              id = prop.id;
          var now = new Date().getTime();
          var diff = now - created;

          if (diff >= lifetime) {
            _this.removeProp(id);
          }
        });
      }
    }
  }, {
    key: "addProp",
    value: function addProp() {
      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var lifetime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var data = arguments.length > 2 ? arguments[2] : undefined;
      var items = this.getItem(this.fieldName);

      var newItems = _defineProperty({}, id, {
        id: id,
        lifetime: lifetime,
        created: new Date().getTime(),
        data: data
      });

      var obj = items ? _objectSpread({}, items, {}, newItems) : newItems;
      this.setItem(this.fieldName, obj);
      this.opts.onAddProp.call(this, id);
    }
  }, {
    key: "hasItem",
    value: function hasItem(id) {
      return !!this.getProp(id);
    }
  }, {
    key: "getProp",
    value: function getProp(id) {
      var items = this.getItem(this.fieldName);
      return items && items[id];
    }
  }, {
    key: "removeProp",
    value: function removeProp(id) {
      var items = this.getItem(this.fieldName);
      delete items[id];
      this.setItem(this.fieldName, items);
      this.opts.onDeleteProp.call(this, id);
    }
  }, {
    key: "getItem",
    value: function getItem(prop) {
      return JSON.parse(this.storage.getItem(prop));
    }
  }, {
    key: "setItem",
    value: function setItem(prop, value) {
      this.storage.setItem(prop, JSON.stringify(value));
    }
  }]);

  return StorageHelper;
}();

var _default = StorageHelper;
exports["default"] = _default;

},{}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _cookieManager = _interopRequireDefault(require("./cookie-manager"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UserInfo =
/*#__PURE__*/
function () {
  function UserInfo() {
    _classCallCheck(this, UserInfo);

    this.cookieManager = new _cookieManager["default"]();
    this.ttl = 10;
  }

  _createClass(UserInfo, [{
    key: "prepareEuropeUserCookie",
    value: function prepareEuropeUserCookie() {
      var _this = this;

      var europeIdentifyEvent = new CustomEvent('EuropeIdentifyEvent');
      var europeIdentifyEventInterval = setInterval(function () {
        _this.ttl--;

        var isEuropeUserCookieExist = _this.cookieManager.isCookieExist('isEuropeUser');

        if (isEuropeUserCookieExist == true) {
          clearInterval(europeIdentifyEventInterval);
          document.dispatchEvent(europeIdentifyEvent);
        } else if (_this.ttl <= 0) {
          clearInterval(europeIdentifyEventInterval);
          var isLocalEnv = window.location.hostname == 'www-impv' || false;

          _this.cookieManager.createCookie('isEuropeUser', isLocalEnv);

          document.dispatchEvent(europeIdentifyEvent);
        }
      }, 500);
    }
  }, {
    key: "isEuropeUser",
    value: function isEuropeUser() {
      return new _cookieManager["default"]().getCookieValue('isEuropeUser');
    }
  }]);

  return UserInfo;
}();

exports["default"] = UserInfo;

},{"./cookie-manager":9}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var UTMHelper =
/*#__PURE__*/
function () {
  function UTMHelper() {
    _classCallCheck(this, UTMHelper);
  }

  _createClass(UTMHelper, [{
    key: "storeUTMParam",
    // get GTM parameters in URL if it exists
    value: function storeUTMParam(sessionName) {
      // set the utm paramters in sessionStorage
      var utmSession = sessionStorage.getItem(sessionName); // only run if there are no sessionStorage

      if (utmSession == null) {
        // began new query string
        var utmStr = ''; // cannot use index because we cannot assume all parameters are utm parameters

        var numOfParams = 0;

        var urlStr = window.location.search.substring(1),
            urlStrArr = urlStr.split('&'),
            isAlphaNumeric = function isAlphaNumeric(str) {
          return /^[a-zA-Z0-9-_]+$/gi.test(str);
        };

        urlStrArr.forEach(function (val) {
          var kvpair = val.split('='),
              key = kvpair[0],
              strvalue = kvpair[1];

          if ((key === 'utm_medium' || key === 'utm_source' || key === 'utm_campaign' || key === 'utm_content' || key === 'utm_device' || key === 'utm_matchtype' || key === 'utm_term' || key === 'utm_parent' || key === 'utm_destination' || key === 'utm_category' || key === 'Lead-Source') && isAlphaNumeric(strvalue)) {
            if (numOfParams > 0) utmStr += '&'; // add ampersand query separators

            utmStr += val; // add key value

            numOfParams++; // increment only num of utm parameters
          }
        }); // set the utm paramters in sessionStorage if there are parameters

        if (numOfParams > 0) {
          // const sanitizedUTM = encodeURI(utmStr);
          sessionStorage.setItem(sessionName, utmStr);
        }
      } // run retrieve UTM if one exists
      else {
          this.retrieveUTMParam(sessionName);
        }
    }
  }, {
    key: "retrieveUTMParam",
    value: function retrieveUTMParam(sessionName) {
      // set the utm paramters in sessionStorage
      var utmSession = sessionStorage.getItem(sessionName),
          urlStr = window.location.search;
      console.log('Retrieve UTM'); // TODO: monitor then remove
      // if session exists, append to url, only if a utm_ paramter does not exist

      if (utmSession && !urlStr.includes('utm_')) {
        // determine whether to append or replace on the URL
        var finalQuery = urlStr ? urlStr + '&' + utmSession : '?' + utmSession;
        window.history.pushState('', document.title, finalQuery);
      } // reset the new parameter session storage
      else if (utmSession && urlStr.includes('utm_')) {
          sessionStorage.removeItem(sessionName);
          this.storeUTMParam(sessionName);
        }
    }
  }]);

  return UTMHelper;
}();

exports["default"] = UTMHelper;

},{}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _userInfo = _interopRequireDefault(require("./components/user-info"));

var _cookieConsent = require("./components/cookie-consent");

var _gtm_click_event_handler = require("./components/gtm_click_event_handler");

var _utmHelper = _interopRequireDefault(require("./components/utm-helper"));

var _carousel = _interopRequireDefault(require("./components/carousel"));

var _dropdownSelect = _interopRequireDefault(require("impv/src/js/components/dropdown-select"));

require("impv/src/js/web-vitals");

require("impv/src/js/components/onetrust");

var _bannerGeolocation = _interopRequireDefault(require("./components/banner-geolocation"));

var _bannerManagement = _interopRequireDefault(require("./components/banner-management"));

var _addVisitedCookie = _interopRequireDefault(require("./components/add-visited-cookie"));

require("./components/drift-up");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var App =
/*#__PURE__*/
function () {
  function App() {
    _classCallCheck(this, App);

    this.init();
  }

  _createClass(App, [{
    key: "init",
    value: function init() {
      jQuery(function () {
        // prepare EuropeUser Cookie
        new _userInfo["default"]().prepareEuropeUserCookie(); // register to cookie-consent event

        (0, _cookieConsent.registerCookieConsent)(); // init gtm event

        (0, _gtm_click_event_handler.initGTMScript)(); // track GTM across pages

        var utmHelperInstance = new _utmHelper["default"]();
        utmHelperInstance.storeUTMParam('utm-params'); // register Carousel elements

        _carousel["default"].register(); // register DropDownSelect


        _dropdownSelect["default"].register(); // BannerGeo should be inited before BannerManagement


        new _bannerGeolocation["default"]();
        new _bannerManagement["default"](); // add cookie on first user's visite

        (0, _addVisitedCookie["default"])();
      });
    }
  }]);

  return App;
}();

var _default = new App();

exports["default"] = _default;

},{"./components/add-visited-cookie":4,"./components/banner-geolocation":5,"./components/banner-management":6,"./components/carousel":7,"./components/cookie-consent":8,"./components/drift-up":10,"./components/gtm_click_event_handler":12,"./components/user-info":15,"./components/utm-helper":16,"impv/src/js/components/dropdown-select":11,"impv/src/js/components/onetrust":13,"impv/src/js/web-vitals":19}],18:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.translate = exports["default"] = void 0;

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function byString(o, s) {
  try {
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties

    s = s.replace(/^\./, ''); // strip a leading dot

    var a = s.split('.');

    for (var i = 0, n = a.length; i < n; ++i) {
      var k = a[i];

      if (k in o) {
        o = o[k];
      } else {
        return;
      }
    }

    return o;
  } catch (error) {
    return undefined;
  }
}

var TranslateService =
/*#__PURE__*/
function () {
  _createClass(TranslateService, null, [{
    key: "instance",
    get: function get() {
      if (!global.TranslateService) {
        global.TranslateService = new TranslateService();
      }

      return global.TranslateService;
    }
  }]);

  function TranslateService() {
    _classCallCheck(this, TranslateService);

    this.translate = this.translate.bind(this);
  }

  _createClass(TranslateService, [{
    key: "getTranlateMap",
    value: function getTranlateMap() {
      if (!this.tranlateMap) {
        this.tranlateMap = window.TranslateMap;
      }

      return this.tranlateMap;
    }
    /**
     * translate and field from Translate Option page on WP admin
     *
     * @param {string} field the field name (i.e. 'marketo_form.full_name_error_message')
     * @param {string | any} defaultValue if value is not exsist return this default value
     * @return {string} the translated text (or default value)
     *
     * @example
     *    import { translate } from 'impv/src/js/services/translate-service';
     *    translate('section.field_name', 'some_default_value_str');
     * 
     */

  }, {
    key: "translate",
    value: function translate() {
      var field = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var tranlateMap = this.getTranlateMap();

      if (!field || !tranlateMap) {
        return defaultValue;
      } else {
        return byString(tranlateMap, field) || defaultValue;
      }
    }
  }]);

  return TranslateService;
}();

var _default = TranslateService.instance;
exports["default"] = _default;
var translate = TranslateService.instance.translate;
exports.translate = translate;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{}],19:[function(require,module,exports){
(function (global){
"use strict";

var _webVitals = require("web-vitals");

function sendToGoogleAnalytics(_ref) {
  var name = _ref.name,
      delta = _ref.delta,
      id = _ref.id;

  if (!global.dataLayer) {
    global.dataLayer = [];
  }

  global.dataLayer.push({
    event: 'web-vitals',
    event_category: 'Web Vitals',
    event_action: name,
    event_value: Math.round(name === 'CLS' ? delta * 1000 : delta),
    event_label: id
  });
}

(0, _webVitals.getCLS)(sendToGoogleAnalytics);
(0, _webVitals.getFID)(sendToGoogleAnalytics);
(0, _webVitals.getLCP)(sendToGoogleAnalytics);
(0, _webVitals.getFCP)(sendToGoogleAnalytics);
(0, _webVitals.getTTFB)(sendToGoogleAnalytics);

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})
},{"web-vitals":3}],20:[function(require,module,exports){
var css = "@media (min-width: 1420px){.new-width .container{width:100%;max-width:1780px}}.cookie-consent-banner{display:none}body.show-cookie-consent-banner .cookie-consent-banner{display:flex;position:fixed;bottom:0;width:100%;padding:10px 0px;font-family:'Inter', sans-serif;color:#ffffff;font-size:14px;line-height:18px;background-color:#4c4c4c;min-height:43px;z-index:210}@media (max-width: 767.98px){body.show-cookie-consent-banner .cookie-consent-banner{position:relative !important}}@media (min-width: 768px){body.show-cookie-consent-banner .cookie-consent-banner{padding:15px;line-height:20px}}body.show-cookie-consent-banner .cookie-consent-banner .content-text{padding-right:30px;margin:0px;color:inherit;font-size:14px}@media (min-width: 768px){body.show-cookie-consent-banner .cookie-consent-banner .content-text{padding-right:unset;padding-left:30px}}body.show-cookie-consent-banner .cookie-consent-banner .content-text a{color:#ffffff;text-decoration:underline}body.show-cookie-consent-banner .cookie-consent-banner .content-text .close-btn-consent{font-size:25px;line-height:1;position:absolute;right:15px;top:-2px;cursor:pointer;text-decoration:none}@media (min-width: 768px){body.show-cookie-consent-banner .cookie-consent-banner .content-text .close-btn-consent{font-size:35px;right:unset;left:0px;top:-11px}}@media (min-width: 1200px){body.show-cookie-consent-banner .cookie-consent-banner .content-text .close-btn-consent{font-size:38px}}@media (min-width: 768px){body.show-cookie-consent-banner div#livechat-compact-container{margin-bottom:40px}}@media (min-width: 1024px){body.show-cookie-consent-banner div#livechat-compact-container{margin-bottom:30px}}\n\n/*# sourceMappingURL=cookie-consent.scss.map */"
module.exports = require('scssify').createStyle(css, {"href":"themes/impv/src/scss/components/cookie-consent.scss"})
},{"scssify":2}]},{},[17]);
